import { C4ListResponse } from '@domain/interface/c4-list-response';
import { createAction, props } from '@ngrx/store';
import { ProjectDTO, Owner, CustomerDTO } from 'cargo-chief-commons';

export const PROCUREMENT = {
	PROJECTS_LIST: {
		GET: createAction('[Procurement] Get Projects', props<any>()),
		SUCCESS: createAction('[Procurement] Get Projects success', props<C4ListResponse<ProjectDTO>>()),
		FAILURE: createAction(
			'[Procurement] Get Projects failure',
			props<{ payload: { message: string } }>()
		),
	},
	USERS_LIST: {
		SET: createAction('[Procurement UsersList] Set Users List', props<{ usersList: Owner[] }>()),
	},
	SORT: {
		SET: createAction('[SORT] Procurement Set sort', props<{ sort: any[] }>()),
	},
	FILTERS: {
		SET: createAction('[FILTERS] Procurement Set filters', props<{ filters: any[] }>()),
	},
	EDIT_PROJECT: {
		OPEN_DIALOG: createAction(
			'[Procurement EDIT_PROJECT] Open dialog',
			props<{
				projects: any;
				action: string;
				title: string;
				cancelButtonText: string;
				confirmButtonText: string;
				usersList?: any;
				projectAction?: string;
				projectIds?: string[];
			}>()
		),
		UPDATE: createAction('[Procurement UPDATE] Update Projects', props<{ payload: any }>()),
		UPDATE_SUCCESS: createAction(
			'[Procurement UPDATE_SUCCESS] Projects update successful',
			props<{ updatedProjects: Record<string, ProjectDTO> }>()
		),
		UPDATE_FAILED: createAction('[Procurement UPDATE_FAILED] Projects update failed', props<any>()),
		CLOSE: createAction('[Procurement CLOSE] Close update projects dialog', props<any>()),
		UPDATE_DUE_DATE: createAction(
			'[Procurement UPDATE_DUE_DATE] update projects due date',
			props<{ dueDate: Date; projectIds: string[] }>()
		),
		UPDATE_CUSTOMER: createAction(
			'[Procurement UPDATE_CUSTOMER] update projects customer',
			props<{ customerDTO: CustomerDTO; projectIds: string[] }>()
		),
		UPDATE_ASSIGNEE: createAction(
			'[Procurement UPDATE_ASSIGNEE] update projects assignee',
			props<{ assigneeId: number; projectIds: string[] }>()
		),
		UPDATE_OUT_OF_NETWORK: createAction(
			'[Procurement UPDATE_OUT_OF_NETWORK] update projects out of network',
			props<{ sendToOutOfNetworkCarriers: boolean; projectIds: string[] }>()
		),
	},
	ARCHIVE_PROJECTS: {
		ARCHIVE: createAction('[Procurement ARCHIVE] Archive selected projects', props<any>()),
		ARCHIVE_SUCCESS: createAction('[Procurement ARCHIVE_SUCCESS] Projects archived', props<any>()),
		ARCHIVE_FAILED: createAction('[Procurement ARCHIVE_FAILED] Failed to archive projects', props<any>()),
	},
	UPLOAD_PROJECTS: {
		OPEN_DIALOG: createAction(
			'[Procurement UPLOAD_PROJECTS] Open dialog',
			props<{
				dataType: string;
				title: string;
				subtitle: string;
				secondStepTitle: string;
				thirdStepTitle: string;
			}>()
		),
		UPLOAD: createAction('[Procurement UPLOAD] Upload projects', props<any>()),
		SUCCESS: createAction('[Procurement SUCCESS] Projects upload successful', props<any>()),
		FAILURE: createAction('[Procurement FAILURE] Projects upload failed', props<any>()),
		CLOSE: createAction('[Procurement CLOSE] Close dialog', props<any>()),
	},
	CREATE_PROJECT: {
		OPEN_DIALOG: createAction('[Procurement CREATE_PROJECT] Open project dialog', props<any>()),
		SUCCESS: createAction('[Procurement SUCCESS] Project created successfully', props<any>()),
		FAILURE: createAction('[Procurement FAILURE] Failed to create project', props<any>()),
		CLOSE: createAction('[Procurement CLOSE] Close dialog', props<any>()),
	},

	ACTIVE_TAB: {
		SET: createAction('[ACTIVE_TAB] Procurement Set ACTIVE_TAB', props<{ activeTab: string }>()),
	},

	CUSTOM_TAB: {
		GET: createAction('[Procurement CUSTOM TAB] Get Custom Tab', props<any>()),
		DELETE: createAction('[Procurement CUSTOM TAB] Delete Custom Tab', props<any>()),
		DELETE_SUCCESS: createAction('[Procurement CUSTOM TAB] Delete Custom Tab Success', props<any>()),
		SUCCESS: createAction('[Procurement CUSTOM TAB] Get Custom Tab Success', props<any>()),
		FAILURE: createAction(
			'[Procurement CUSTOM TAB]Get Custom Tab Failure',
			props<{ payload: { message: string } }>()
		),
	},
	TABS: {
		SET: createAction('[Procurement TABS] Set tabs', props<{ allTabs: string[] }>()),
	},

	USERS_SORT_AND_FILTERS: {
		GET: createAction('[Procurement TABS] get saved users sorts and filters', props<any>()),
		SUCCESS: createAction('[Procurement TABS] get saved users sorts and filters success', props<any>()),
		FAILURE: createAction('[Procurement TABS] get saved users sorts and filters failure', props<any>()),
		SET: createAction('[Procurement TABS] Set saved custom tabs and filters', props<any>()),
	},

	BA: {
		OPEN_DIALOG: createAction('[Procurement] open BA form dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Procurement] close BA form dialog', props<any>()),
	},


};
